import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-fairplay',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './fair-play.component.html',
  styleUrl: './fair-play.component.scss',
})
export class FairPlayComponent {}
